/**
 * MODULE: _shared/frontend-shell/src/layout/mobileShell/MobileShellDocumentSync.tsx
 * PURPOSE: Sync `data-mobile-shell` on `<html>` for all routes (auth, share, AppLayout).
 * PUBLIC_API: MobileShellDocumentSync
 * SIDE_EFFECTS: document.documentElement dataset
 * AGENT_SAFETY: SAFE
 */

import { useEffect } from 'react';

import { useMobileShellState } from './useMobileShellState';

function syncMobileShellDocumentFlag(active: boolean): void {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.mobileShell = active ? 'true' : 'false';
}

/** Mount once at app root so `.mobile-shell-only` CSS works on public routes. */
export function MobileShellDocumentSync() {
  const { isMobileShell } = useMobileShellState();

  useEffect(() => {
    syncMobileShellDocumentFlag(isMobileShell);
  }, [isMobileShell]);

  return null;
}
